import { render, staticRenderFns } from "./DepartmentMembers.vue?vue&type=template&id=5447ee5f&scoped=true"
import script from "./DepartmentMembers.vue?vue&type=script&lang=js"
export * from "./DepartmentMembers.vue?vue&type=script&lang=js"
import style0 from "./DepartmentMembers.vue?vue&type=style&index=0&id=5447ee5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5447ee5f",
  null
  
)

export default component.exports